import React from 'react'
import PropTypes from 'prop-types'
import css from './weekday.css'

const Weekday = ({ active, dayName, dayOfMonth }) => (
  <div className={active ? css.activeDay : css.day}>
    <div className={css.weekdayContent}>
      <span className={css.dayName}>{dayName}</span>
      <br />
      <span>{dayOfMonth}</span>
    </div>
  </div>
)

Weekday.propTypes = {
  active: PropTypes.bool.isRequired,
  dayName: PropTypes.string.isRequired,
  dayOfMonth: PropTypes.string.isRequired,
}

export default Weekday



// WEBPACK FOOTER //
// ./src/components/Schedule/Header/Weekday.js